module.exports = __webpack_public_path__ + "img/background-image.62beb88f.png";